import React from "react";
import { useTranslation } from "react-i18next";
import { MAX_ORGANIZATION_NAME } from "../../lib/platformValidation";

/**
 * The retyped organization name that unlocks a destructive action.
 *
 * The value is compared EXACTLY (only surrounding whitespace is forgiven), both
 * here and again in the database. Nothing is pre-filled and nothing is
 * auto-completed: the point of the field is that a human reads the name and
 * types it.
 */
export const PlatformConfirmNameField = ({
  idPrefix,
  name,
  value,
  onChange,
  disabled = false,
  error,
}) => {
  const { t } = useTranslation();
  const id = `${idPrefix}-confirm-name`;

  return (
    <div className="qw-field">
      <label htmlFor={id}>{t("platform.confirm_name_label")}</label>
      <input
        id={id}
        className="qw-input"
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        autoComplete="off"
        spellCheck={false}
        maxLength={MAX_ORGANIZATION_NAME}
        aria-invalid={error ? "true" : undefined}
        data-testid={id}
      />
      <div className="qw-help" data-testid={`${id}-help`}>
        {t("platform.confirm_name_help", { name })}
      </div>
      {error && (
        <div className="qw-error" data-testid={`${id}-error`}>
          {error}
        </div>
      )}
    </div>
  );
};

export default PlatformConfirmNameField;
